import { create } from 'zustand';
import type { AuthSession, UserIdentity } from '../types/auth.types';

export const AUTH_STORAGE_KEY = 'vanialabs_auth_session';

export interface AuthState {
  session: AuthSession | null;
  isInitialized: boolean;

  isAuthenticated: () => boolean;

  setSession: (session: AuthSession) => void;
  setUser: (user: UserIdentity) => void;
  setActiveContext: (contextId: string | undefined) => void;

  clearSession: () => void;
  restoreSession: () => void;

  setInitialized: (value: boolean) => void;
}


function persistSession(session: AuthSession | null) {
  if (session) {
    localStorage.setItem(
      AUTH_STORAGE_KEY,
      JSON.stringify(session)
    );
  } else {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  }
}


export const useAuthStore = create<AuthState>((set, get) => ({

  session: null,

  isInitialized: false,


  isAuthenticated: () => {
    const session = get().session;

    return Boolean(
      session &&
      session.accessToken
    );
  },


  setSession: (session) => {

    persistSession(session);

    set({
      session,
      isInitialized: true,
    });

  },


  setUser: (user) => {

    const current = get().session;

    if (!current) {
      return;
    }


    const updated = {
      ...current,
      user,
    };


    persistSession(updated);

    set({
      session: updated,
    });

  },


  setActiveContext: (contextId) => {

    const current = get().session;

    if (!current) {
      return;
    }


    const updated =
      contextId !== undefined
        ? {
            ...current,
            activeContextId: contextId,
          }
        : current;


    persistSession(updated);


    set({
      session: updated,
    });

  },


  clearSession: () => {

    persistSession(null);


    set({
      session: null,
      isInitialized: true,
    });

  },


  restoreSession: () => {

    const raw =
      localStorage.getItem(
        AUTH_STORAGE_KEY
      );


    if (!raw) {

      set({
        session: null,
        isInitialized: true,
      });

      return;
    }


    try {

      const session =
        JSON.parse(raw) as AuthSession;


      if (
        !session ||
        !session.accessToken
      ) {

        localStorage.removeItem(
          AUTH_STORAGE_KEY
        );


        set({
          session: null,
          isInitialized: true,
        });


        return;
      }


      set({

        session,

        isInitialized: true,

      });


    } catch {

      localStorage.removeItem(
        AUTH_STORAGE_KEY
      );


      set({

        session: null,

        isInitialized: true,

      });

    }

  },


  setInitialized: (value) => {

    set({
      isInitialized: value,
    });

  },


}));
